module.exports = __webpack_public_path__ + "static/media/shengdiao016.cee9e9c9.jpg";